import React from 'react';
import { FormattedMessage } from 'react-intl';

function FormattedLabel({
  children,
  label
}) {
  const value = children || label;

  if (React.isValidElement(value) || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return React.createElement(React.Fragment, null, value);
  }

  return React.createElement(FormattedMessage, value);
}

export default FormattedLabel;